import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  withStyles,
} from "@material-ui/core"
import { createTheme, responsiveFontSizes } from "@mui/material/styles"
import React, { useEffect, useState } from "react"
import { getDisplayName } from "../../../util/deviceHelpers"
import WidgetCommon from "../Common/widgetCommon"

let theme = createTheme()
theme = responsiveFontSizes(theme)
const styles = () => ({})

const popperProps = {
  modifiers: [
    {
      name: "offset",
      options: {
        offset: [0, -30],
      },
    },
  ],
}

const HoursSinceLastTable = (props) => {
  const {
    isLoading,
    insights,
    devices,
    allowEdits,
    handleWidgetChange,
    widgetId,
    gridStep,
    position,
    size,
    handleRemove,
  } = props
  const [graphData, setGraphData] = useState([])

  useEffect(() => {
    if (devices && insights) {
      const currentDate = new Date(Date.now() + new Date().getTimezoneOffset() * 60 * 1000)
      const dataMap = {}
      for (const device of devices) {
        if (device.last_seen) {
          dataMap[device.device_id] = {
            device_id: device.device_id,
            device_name: getDisplayName(device),
            hours_check_in: Math.floor(
              (currentDate - new Date(device.last_seen)) / (1000 * 60 * 60),
            ),
            hours_camera_trigger: device.hours_since_last_camera_trigger,
          }
        }
      }
      for (const insight of insights) {
        if (insight.device_id && insight.device_id in dataMap) {
          const insightTime = new Date(insight.time_stamp)
          if (
            !dataMap[insight.device_id].insight_time ||
            dataMap[insight.device_id].insight_time < insightTime
          ) {
            dataMap[insight.device_id].insight_time = insightTime
            dataMap[insight.device_id].hours_insight = Math.floor(
              (currentDate - insightTime) / (1000 * 60 * 60),
            )
          }
        }
      }
      setGraphData(Object.values(dataMap))
    }
  }, [insights, devices])

  return (
    <WidgetCommon
      widgetId={widgetId}
      title="Last Device Communication (Hours)"
      isLoading={isLoading}
      hasNoData={graphData.length === 0}
      tooMuchDataString="Too many devices. Please filter to fewer devices."
      info="Hours since last insight can change based on the filters applied to the data."
      size={size}
      position={position}
      allowResize={true}
      allowEdits={allowEdits}
      handleWidgetChange={handleWidgetChange}
      gridStep={gridStep}
      handleRemove={handleRemove}
    >
      <TableContainer
        component={Paper}
        style={{ overflow: "scroll", maxHeight: `${0.6 * (gridStep * size.height)}px` }}
      >
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Device Name</TableCell>
              <TableCell>Check-In</TableCell>
              <TableCell>Insight</TableCell>
              <TableCell>Reported Camera Trigger</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {graphData.map((row) => (
              <Tooltip
                key={row.device_id}
                PopperProps={popperProps}
                arrow
                interactive
                title={row.device_name}
              >
                <TableRow>
                  <TableCell>{row.device_name}</TableCell>
                  <TableCell>{row.hours_check_in}</TableCell>
                  <TableCell>{row.hours_insight}</TableCell>
                  <TableCell>{row.hours_camera_trigger}</TableCell>
                </TableRow>
              </Tooltip>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </WidgetCommon>
  )
}

export default withStyles(styles)(HoursSinceLastTable)
